module.exports = __webpack_public_path__ + "static/media/img14.9949e2e4.jpg";